module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0118.jpg?v=9db6cc41";